import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { alertSuccessMsg, executeStored } from 'app/main/components/Utils';
import useSettings from 'app/main/components/hooks/useSettings';
import Form from 'app/main/components/Form';
import ModuleSearchField from 'app/main/components/fields/ModuleSearchField';

interface VisibilityGroupsAddDialogProps {
	module: string;
	uid: string;
	updateRefresh: VoidFunction;
}

export const showVisibilityGroupsAddDialog = (props: VisibilityGroupsAddDialogProps) =>
	openDialog({
		children: <VisibilityGroupsAddDialog {...props} />,
		maxWidth: 'xs',
		fullWidth: true
	});

export function VisibilityGroupsAddDialog({ module, uid, updateRefresh }: VisibilityGroupsAddDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(module);

	const [groupUid, setGroupUid] = React.useState('');

	function handleChange(_name, value) {
		setGroupUid(value);
	}

	function addGroup() {
		executeStored({
			action: `st_${module}_groups_add`,
			dispatch,
			data: {
				[`${settings.modu_short}_uid`]: uid,
				grps_uid: groupUid
			},
			successHandler: () => {
				dispatch(alertSuccessMsg(t));
				dispatch(closeDialog());
				updateRefresh();
			}
		});
	}

	return (
		<>
			<DialogTitle>{t('DIALOG_GROUP_ADD_TITLE')}</DialogTitle>
			<DialogContent>
				<Form id="visibilityGroupsAddDialog" onSubmit={addGroup}>
					<ModuleSearchField
						name="new_group"
						label={t('DIALOG_GROUP_ADD_GROUP_FIELD')}
						module="groups"
						uid={groupUid}
						isEdit
						sendChange={handleChange}
					/>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="visibilityGroupsAddDialog" color="secondary">
					{t('DIALOG_ACTION_ADD')}
				</Button>
			</DialogActions>
		</>
	);
}
